export const getCsrfToken = (): string => {
  const match = document.cookie.match(/(?:^|; )csrf_token=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : '';
};

export const withCsrfHeader = (headers: Record<string, string> = {}) => {
  const token = getCsrfToken();
  return token ? { ...headers, 'X-CSRF-Token': token } : headers;
};
